import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получить топ упоминаемых монет
export const getTopMentionedCoins = async () => {
  const url = `${backendUrl}/api/widgets/top-mentioned-widget/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка при получении топ упоминаемых монет: HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data
  } catch (error) {
    console.error('Ошибка получения топ упоминаемых монет:', error);
    throw error;
  }
};